import React from "react";

import Vimeo from "@u-wave/react-vimeo";

import { useAppType, useTranslation } from "utils";

import { Icon, LazyLoadImage } from "components";

export const CourseModule = ({ chapter, module }) => {
  const { t } = useTranslation("courses");
  const appType = useAppType();

  const [isPlaying, setIsPlaying] = React.useState(false);

  const getPlaceholderImage = () => {
    if (module.video) {
      if (appType.desktop && module.placeholderImages.desktop) {
        return module.placeholderImages.desktop;
      }
      if (module.placeholderImages.mobile) {
        return module.placeholderImages.mobile;
      }
    }
    return <></>;
  };

  return (
    <div className="course-drawer">
      <p className="grey-600-text paragraph-s">{t("module.chapterTitle", { chapterTitle: chapter.title })}</p>
      <h2>{module.title}</h2>
      {module.video ? (
        <div className="vimeo-container">
          {(isPlaying || !getPlaceholderImage()) && (
            <Vimeo className="vimeo-player" autoplay responsive video={module.video} showByline={false} showPortrait={false} showTitle={false} />
          )}
          {!isPlaying && getPlaceholderImage() && (
            <>
              <LazyLoadImage src={getPlaceholderImage().link} alt={module.title} width="100%" />
              <div className="play-button" onClick={() => setIsPlaying(true)}>
                <Icon iconName="tabler/player-play" color="#fff" fill="#fff" size="xxl" />
              </div>
            </>
          )}
        </div>
      ) : (
        <div>
          <LazyLoadImage className="module-image" src={module.image} alt={module.title} width="100%" />
        </div>
      )}
      <div className="module-container">
        <div className="content" dangerouslySetInnerHTML={{ __html: module.content }}></div>
        <div className="takeaways">
          <h2>{t("module.takeaways")}</h2>
          <ul>
            {module.takeaways
              .filter((takeaway) => takeaway)
              .map((takeaway, index) => (
                <li key={index}>{takeaway}</li>
              ))}
          </ul>
        </div>
      </div>
    </div>
  );
};
